import {Component, Inject, Input, OnInit} from '@angular/core';
import {ConfService} from '../conf.service';
import {KongService} from '../kong.service';
import {MatDialog} from '@angular/material/dialog';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {ConnecttocrudService} from '../connecttocrud.service';
import {Router} from '@angular/router';
import {EmailtemplateService} from '../emailtemplate.service';
import {FormControl} from '@angular/forms';
import {CreateUserComponent} from '../manage-users1/create-user-component/create-user.component';
import {CreateUserGroupDialogComponent} from './create-user-group-dialog/create-user-group-dialog.component';
import {environment} from '../../environments/environment';
import {AddEnvironmentDialogComponent} from '../manage-users1/add-environment/add-environment-dialog.component';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {AccountInfoService} from '../user/account-info.service';

@Component({
    selector: 'app-manage-user-groups',
    templateUrl: './manage-user-groups.component.html',
    styleUrls: ['./manage-user-groups.component.scss']
})
export class ManageUserGroupsComponent implements OnInit {

    @Input() partner = localStorage.getItem('partner');
    environmentList = [];
    selectedUserList = new FormControl();

    usersList: any;
    selectedRoles = new FormControl();
    partnerName: any;
    userGroups: any;

    rolesList: any;

    searchText: any;
    dataFound = false;

    constructor(private confPost: ConfService,
                public accountInfoService: AccountInfoService,
                public dialog: MatDialog,
                public platform: LeftpanelComponent,
                public _service: ConnecttocrudService,
                public router: Router,
                public emailTemplateInstance: EmailtemplateService) {
    }

    ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        this.partnerName = localStorage.getItem('partner');
        this.getEnvironments();
        this.getUsergroups();
    }

    getEnvironments() {
        this.confPost.getSettingsV2CRUD(this.partner, this.partner, false).subscribe(response => {
            if (response) {

                for (const item of response['body'][0]['environments']) {
                    if (item['type'] !== 'admin') {
                        this.environmentList.push(item['name']);
                    }
                }
            }
        });
    }

    getUsergroups() {
        const shortName = this.partnerName.split('-');
        this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'usergroups', 'partner.in=' + shortName[shortName.length - 1]).subscribe(res => {
            if (res) {
                let usergroup: any;
                usergroup = res;
                this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'partner.in=services&&type.in=platform').subscribe(roles => {
                    if (roles) {
                        this.rolesList = roles;
                        this.rolesList = this.rolesList.filter(value => value['role'] !== 'Platform Admin' && value['role'] !== 'Super Admin' && !value['role'].includes('=>'));
                        this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', 'partner.in=' + shortName[shortName.length - 1]).subscribe(users => {
                            if (users) {
                                this.usersList = this.getFilterUserDetails(users);
                                for (let user of usergroup) {
                                    const elist = [];
                                    // if(user['status']){
                                    //
                                    // }

                                    for (let e of user['environments']) {
                                        e['rolesList'] = roles;
                                        elist.push(e['name']);
                                        const role_list = [];
                                        e['platform_roles'] = [];
                                        for (const eee of e['rolesList']) {
                                            if (eee['role'] !== 'Platform Admin' && eee['role'] !== 'Super Admin' && !eee['role'].includes('=>')) {
                                                role_list.push(eee);
                                                e['platform_roles'].push(eee['id']);
                                            }
                                        }
                                        e['userlist'] = this.usersList;
                                        const user_list = [];
                                        e['available_users'] = [];
                                        for (const u of e['userlist']) {
                                            const shortName = u['user'].split('-');
                                            if (shortName[0] !== 'admin') {
                                                user_list.push(u);
                                                e['available_users'].push(u['id']);
                                            }
                                        }
                                        e['userlist'] = user_list;
                                        e['rolesList'] = role_list;
                                        e['selected_roles' + e['name']] = e['roles'];
                                        e['selected_users' + e['name']] = e['users'];
                                        e['user_edit_status'] = true;
                                        e['role_edit_status'] = true;
                                        e['exlusions_peresent'] = false;
                                        if (e['exclusions']['permission_groups'].length > 0) {
                                            e['exlusions_peresent'] = true;
                                            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissiongroups', 'id.in=' + e['exclusions']['permission_groups'].toString()).subscribe(permissiongroups => {
                                                e['exclusions']['permission_groups'] = permissiongroups;
                                            });
                                        }
                                        if (e['exclusions']['permissions'] > 0) {
                                            e['exlusions_peresent'] = true;
                                            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissions', 'id.in=' + e['exclusions']['permissions'].toString()).subscribe(permissions => {
                                                e['exclusions']['permissions'] = permissions;
                                            });
                                        }

                                        if (e['exclusions']['roles'] > 0) {
                                            e['exlusions_peresent'] = true;
                                            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'id.in=' + e['exclusions']['permissions'].toString()).subscribe(roles => {
                                                e['exclusions']['roles'] = roles;
                                            });
                                        }
                                    }
                                    user['environmentList'] = elist;
                                }

                                this.userGroups = usergroup;
                                this.dataFound = true;
                            }
                        });
                    }
                });
            }
        });

    }

    stringifyjson(val) {
        if (val != null) {
            return JSON.stringify(val, null, 2).trim();
        } else {
            return val;
        }
    }


    toggleExecutor(ev, a) {
        $('.' + a).slideToggle();
        $(ev.target).toggleClass('fa-chevron-up fa-chevron-down');
    }

    getFilterUserDetails(userDetails) {
        const ud = [];
        for (const user of userDetails) {
            const shortname = user['user'].split('-');
            if (shortname[0] !== 'admin' && user['status']) {
                ud.push(user);
            }
        }

        return ud;
    }
    openDialog(type): void {
        const dialogRef = this.dialog.open(CreateUserGroupDialogComponent, {
            width: '50%',
            data: {
                environments: this.environmentList,
                users: this.usersList,
                roles: this.rolesList,
                groups: this.userGroups
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== undefined && result !== '') {
                this.getUsergroups();
            }
        });
    }

    reRoute(id, e) {
        this.router.navigateByUrl('/assign-roles?id=' + id + '&environment=' + e + '&type=userGroup');
    }

    applyUserChanges(i1, i2, id, ngmodelName, users, environments, eName) {

        this.userGroups[i1]['environments'][i2]['user_edit_status'] = true;
        if (this.userGroups[i1]['environments'][i2][ngmodelName]) {
            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
            });
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'usergroups', 'id=' + id).subscribe(data => {
                const temp = data[0]['environments'][i2]['users'].filter(value => !this.userGroups[i1]['environments'][i2]['available_users'].includes(value));
                data[0]['environments'][i2]['users'] = temp.concat(this.userGroups[i1]['environments'][i2][ngmodelName]);
                this._service.patchItemUpdate(id, {environments: data[0]['environments']}, 'v1', environment.accessPartner, environment.accessPartner, 'usergroups').subscribe(async response => {
                    if (response) {
                        for (const user_id of this.userGroups[i1]['environments'][i2][ngmodelName]) {
                            await this.updateUserGroupsInUser(id, user_id);
                        }
                        for (let u of users) {
                            let flag = false;
                            if (!this.userGroups[i1]['environments'][i2][ngmodelName].includes(u)) {
                                for (let e of environments) {
                                    if (e['name'] !== eName && e['users'].includes(u)) {
                                        flag = true;
                                    }
                                }
                                if (!flag) {
                                    await this.removeUserGroupsInUser(u);
                                }
                            }
                        }
                        loaderDialog.close();
                        this.platform.openSnackBar(' Environments Updated', 'Success', {
                            duration: 2000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        this.getUsergroups();
                    }

                });
            });

        }
    }

    applyRoleChanges(i1, i2, id, ngmodelName) {
        this.userGroups[i1]['environments'][i2]['role_edit_status'] = true;
        if (this.userGroups[i1]['environments'][i2][ngmodelName]) {
            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
            });
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'usergroups', 'id=' + id).subscribe(data => {
                const temp = data[0]['environments'][i2]['roles'].filter(value => !this.userGroups[i1]['environments'][i2]['platform_roles'].includes(value));
                data[0]['environments'][i2]['roles'] = temp.concat(this.userGroups[i1]['environments'][i2][ngmodelName]);
                this._service.patchItemUpdate(id, {environments: data[0]['environments']}, 'v1', environment.accessPartner, environment.accessPartner, 'usergroups').subscribe(response => {
                    if (response) {
                        this.platform.openSnackBar(' Environments Updated', 'Success', {
                            duration: 2000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        this.getUsergroups();
                        loaderDialog.close();
                    }

                });
            });
        }
    }

    deleteUser(id, name, environments) {
        if (confirm('This action is irreversible, The application role associated with user group environments will also be removed. Are you sure you want to delete this user group?')) {
            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
            });
            for (const e of environments) {
                this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'role=' + e['name'] + '=>' + e['account'] + '=>' + name).subscribe(async res => {
                    let roles: any;
                    roles = res;
                    if (roles && roles.length > 0) {
                        await this.deleteRoleForEachEnvironment(roles[0]['id']);
                    }
                });
                for (const user_id of e['users']) {
                    this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', 'id=' + user_id).subscribe(user => {
                        if (user && user[0]) {
                            let temp: any;
                            temp = user[0]['user_groups'];
                            const index = temp.indexOf(id);
                            temp.splice(index, 1);
                            this._service.patchItemUpdate(user[0]['id'], {'user_groups': temp}, 'v1', environment.accessPartner, environment.accessPartner, 'users').subscribe(result => {
                            });
                        }
                    });
                }
            }
            this._service.deleteItem(id, 'v1', environment.accessPartner, environment.accessPartner, 'usergroups').subscribe(data => {
                this.platform.openSnackBar(' User account deleted successfully', 'Success', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                loaderDialog.close();
                this.getUsergroups();
            });
        }
    }

    deleteRoleForEachEnvironment(id) {
        return new Promise((resolve, reject) => {
            this._service.deleteItem(id, 'v1', environment.accessPartner, environment.accessPartner, 'roles').subscribe(data => {
                if (data) {
                    resolve('success');
                } else {
                    resolve('failed');
                }
            }, error => {
                /*this.platform.notifyErrorToAdmins({error: 'Error occurred while creating role for the user ' + roleDetail['role']}, 'role_create_success', 'role_create_failed', 'Error occurred while creating role for the user ' + roleDetail['role'], roleDetail);
                */
                resolve('failed');

            });
        });
    }

    updateUserGroupsInUser(id, user_id) {
        return new Promise((resolve, reject) => {
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', 'id=' + user_id).subscribe(resp => {
                if (resp) {
                    const user = resp;
                    if (!user[0]['user_groups'].includes(id)) {
                        user[0]['user_groups'].push(id);
                        this._service.patchItemUpdate(user[0]['id'], {'user_groups': user[0]['user_groups']}, 'v1', environment.accessPartner, environment.accessPartner, 'users').subscribe(updateRes => {
                            if (updateRes) {
                                resolve('success');
                            }
                        });
                    } else {
                        resolve('success');
                    }
                }
            });
        });
    }

    removeUserGroupsInUser(user_id) {
        return new Promise((resolve, reject) => {
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', 'id=' + user_id).subscribe(user => {
                if (user && user[0]) {
                    let temp: any;
                    temp = user[0]['user_groups'];
                    const index = temp.indexOf(user_id);
                    temp.splice(index, 1);
                    this._service.patchItemUpdate(user[0]['id'], {'user_groups': temp}, 'v1', environment.accessPartner, environment.accessPartner, 'users').subscribe(result => {
                        if (result) {
                            resolve('success');
                        } else {
                            resolve('failed');
                        }
                    });
                }
            });
        });
    }


    addEnvironments(userIndex, id, groupName) {
        const environmentList = this.environmentList.filter(value => {
            if (!this.userGroups[userIndex]['environmentList'].includes(value)) {
                return value;
            }
        });

        const dialogRef = this.dialog.open(AddEnvironmentUserGroupComponent, {
            width: '25%',
            data: {
                id: id,
                environmentList: environmentList,
                groupName: groupName,
                userList: this.usersList
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === 'success') {
                this.platform.openSnackBar(' New Environment Added ', 'Success', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.getUsergroups();
            }
        });
    }

    deleteEnvironment(eName, account, groupId, name, users, environments) {
        if (confirm('This action is irreversible, The application role associated with environment will also be removed. Are you sure you want to delete this environment?')) {
            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
            });
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'role=' + eName + '=>' + account + '=>' + name).subscribe(async res => {
                const tempRole = res[0];
                if (tempRole) {
                    await this.deleteRoleForEachEnvironment(res[0]['id']);
                }

                for (let u of users) {
                    let flag = false;
                    for (let e of environments) {
                        if (e['name'] !== eName && e['users'].includes(u)) {
                            flag = true;
                        }
                    }
                    if (!flag) {
                        this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', 'id=' + u).subscribe(user => {
                            if (user && user[0]) {
                                let temp: any;
                                temp = user[0]['user_groups'];
                                const index = temp.indexOf(u);
                                temp.splice(index, 1);
                                this._service.patchItemUpdate(user[0]['id'], {'user_groups': temp}, 'v1', environment.accessPartner, environment.accessPartner, 'users').subscribe(result => {
                                });
                            }
                        });
                    }
                }

                this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'usergroups', 'id=' + groupId).subscribe(data => {
                    let environments: any;
                    if (data && data[0] && data[0].hasOwnProperty('environments')) {
                        environments = data[0]['environments'];
                        if (environments.length > 0) {
                            const temp = environments.filter(value => value['name'] !== eName);
                            this._service.patchItemUpdate(groupId, {environments: temp}, 'v1', environment.accessPartner, environment.accessPartner, 'usergroups').subscribe(data => {
                                this.platform.openSnackBar(' Environments deleted successfully', 'Success', {
                                    duration: 2000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                                loaderDialog.close();
                                this.getUsergroups();
                            });
                        }
                    }
                });
            });
        }
    }

    editGroup(i1, i2) {
        this.userGroups[i1]['environments'][i2]['user_edit_status'] = false;
        this.userGroups[i1]['environments'][i2]['role_edit_status'] = false;
    }


}

@Component({
    selector: 'add-environment-usergroup-dialog',
    templateUrl: 'add-environment-usergroup-dialog.html',
    styleUrls: ['add-environment-usergroup-dialog.scss']
})
export class AddEnvironmentUserGroupComponent implements OnInit {

    selectedEnvironmentList = new FormControl();
    environmentList: string[];
    selectedUserlist = new FormControl();
    usersList = [];

    constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<AddEnvironmentUserGroupComponent>, public confPost: ConfService, public router: Router, public _service: ConnecttocrudService, public kongService: KongService) {
        dialogRef.disableClose = true;
    }

    ngOnInit() {
        if (this.data['environmentList']) {
            this.environmentList = this.data['environmentList'];
        }
        if (this.data['userList']) {
            this.usersList = this.data['userList'];
        }
    }

    closeDialog() {
        this.dialogRef.close();
    }

    addEnvironment() {
        if (this.selectedUserlist.value.length > 0 && this.selectedEnvironmentList.value.length > 0) {
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'usergroups', 'id=' + this.data['id']).subscribe(async result => {
                if (result) {
                    const shortName = localStorage.getItem('partner').split('-');
                    const userGroupResponse = result[0];

                    for (let e of this.selectedEnvironmentList.value) {
                        const roleDetails = {
                            'role': e + '=>' + e + '=>' + this.data['groupName'],
                            'permission_groups': [],
                            'permissions': [],
                            'roles': [],
                            'exclusions': [],
                            'partner': e,
                            'account': e,
                            'type': 'account'
                        };
                        const roleId = await this.createRoleForEachEnvironment(roleDetails);

                        userGroupResponse['environments'].push(
                            {
                                name: e,
                                account: e,
                                users: this.selectedUserlist.value,
                                roles: [roleId],
                                exclusions: {
                                    permissions: [],
                                    permission_groups: [],
                                    role: []
                                },
                                audit_logs: [
                                    {
                                        action: 'CREATE',
                                        by: shortName[shortName.length - 1],
                                        at: Date.now()
                                    }
                                ]
                            }
                        );
                    }

                    this._service.patchItemUpdate(this.data['id'], {environments: userGroupResponse['environments']}, 'v1', environment.accessPartner, environment.accessPartner, 'usergroups').subscribe(res => {
                        if (res) {
                            for (const user_id of this.selectedUserlist.value) {
                                this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', 'id=' + user_id).subscribe(resp => {
                                    if (resp) {
                                        const user = resp;
                                        if (!user[0]['user_groups'].includes(this.data['id'])) {
                                            user[0]['user_groups'].push(this.data['id']);
                                            this._service.patchItemUpdate(user[0]['id'], {'user_groups': user[0]['user_groups']}, 'v1', environment.accessPartner, environment.accessPartner, 'users').subscribe(updateRes => {
                                                this.platform.openSnackBar('User Group created', 'Success', {
                                                    duration: 2000,
                                                    verticalPosition: 'top',
                                                    horizontalPosition: 'center'
                                                });
                                                this.dialogRef.close('success');
                                            });
                                        }

                                    }
                                });
                            }
                            this.dialogRef.close('success');
                        }
                    });
                }
            });
        } else {
            this.platform.openSnackBar(' Please make sure that your password follows our password policy ', 'Error', {
                duration: 2000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    createRoleForEachEnvironment(roleDetail) {
        return new Promise((resolve, reject) => {
            this._service.addItem(roleDetail, 'v1', environment.accessPartner, environment.accessPartner, 'roles').subscribe(data => {
                if (data) {
                    resolve(data['upsertedId']);
                } else {
                    resolve('failed');
                }
            }, error => {
                /* this.platform.notifyErrorToAdmins({error: 'Error occurred while creating role for the user ' + roleDetail['role']}, 'role_create_success', 'role_create_failed', 'Error occurred while creating role for the user ' + roleDetail['role'], roleDetail);
                */
                resolve('failed');
            });
        });
    }
}
